export default function toMoney(money) {
  if (money === null || money === undefined) {
    return "0,00"
  }
  return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace(".", ",");
}
